import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Homepage from './pages/Homepage';
import Landingpage from './pages/Landingpage';
import AdvisorPageOverview from './pages/AdvisorPageOverview';
import AdvisorPageDetail from './pages/AdvisorPageDetail';
import NewsletterForm from './pages/NewsletterForm';
import ContactForm from './pages/ContactForm';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Homepage />} />
        <Route path='/Landingpage' element={<Landingpage />} />
        <Route path='/AdvisorPageOverview' element={<AdvisorPageOverview />} />
        <Route path='/AdvisorPageDetail' element={<AdvisorPageDetail />} />
        <Route path='/NewsletterForm' element={<NewsletterForm />} />
        <Route path='/ContactForm' element={<ContactForm />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
